module.exports = __webpack_public_path__ + "img/user.6d2b4e7a.svg";